import React from 'react'
import PropTypes from 'prop-types'
import { Input, Button, Icon} from 'semantic-ui-react'
import {MAIN_COLOR} from 'globals/consts'
import './style.css'

class InputPassword extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      type: 'password',
      score: 'null'
    }
    this.showHide = this.showHide.bind(this)
    if (props.showStrength) {
      this.passwordStrength = this.passwordStrength.bind(this)
      import("zxcvbn").then((zxcvbn) => {
        this.zxcvbn = zxcvbn.default
      })
    }
  }

  showHide(e){
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === 'input' ? 'password' : 'input'
    })  
  }

  passwordStrength(e){
    if(e.target.value === ''){
      this.setState({
        score: 'null'
      })
    } else {
      if (this.zxcvbn) {
        this.setState({ score: this.zxcvbn(e.target.value).score })     
      } else {
        var pass = e.target.value
        import("zxcvbn").then((zxcvbn) => {
          this.zxcvbn = zxcvbn.default
          this.setState({ score: this.zxcvbn(pass).score }) 
        })
      }
    }
    this.props.onChange(e)
  }

  render(){
    const { showStrength, onChange, id, name, placeholder,tabIndex,autoComplete } = this.props
    return(
      <div style={{paddingBottom: showStrength ? '8px':'0px'}}>
        <div className='ui input' style={{minHeight: '38px'}}>
          <Input tabIndex={tabIndex} className='allowEnter' id={id} icon='user secret' iconPosition='left' name={name} type={this.state.type} onChange={showStrength ? this.passwordStrength : onChange} placeholder={placeholder} 
            autoComplete={autoComplete}
            action={{
              style: {background: MAIN_COLOR},
              onClick: this.showHide, 
              icon: this.state.type==='input' ? 'eye slash' : 'eye'           
            }}      
          />  
          {showStrength && 
            <span className="password__strength" data-score={this.state.score} />
          }
        </div>    
      </div>
    )
  }
}

InputPassword.defaultProps = {
  showStrength: false
}

// TODO: add value with CORRECT type
InputPassword.propTypes = {
  name: PropTypes.string.isRequired,
  showStrength: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

export default InputPassword;
